import { useCallback, useEffect } from 'react'

export const usePageVisibilityChange = (onVisible: () => void, onHidden: () => void) => {
  const handleChange = useCallback(() => {
    const visibility = document.visibilityState
    if (visibility === 'hidden') {
      onHidden()
    } else if (visibility === 'visible') {
      onVisible()
    }
  }, [onHidden, onVisible])

  useEffect(() => {
    document.addEventListener('visibilitychange', handleChange)

    return () => {
      document.removeEventListener('visibilitychange', handleChange)
    }
  }, [handleChange])
}
